import React from 'react';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import { appWithTranslation } from 'next-i18next';
import { FrontasticProvider, URLHistoryProvider } from '@frontastic-engbers/lib';
import '../styles/app.scss';
import '../styles/themes/default.scss';
import '../styles/themes/theme1.scss';
import '../styles/components/slider.css';
import '../styles/components/default-loader.css';
import { AnimatePresence } from 'framer-motion';
const ToasterComponentDynamic = dynamic(() => import('@engbers/components/online-shops/commercetools-ui/toaster'), {
  ssr: false
});
function FrontasticStarter({
  Component,
  pageProps,
  router
}: AppProps) {
  return <FrontasticProvider context="pwa" data-sentry-element="FrontasticProvider" data-sentry-component="FrontasticStarter" data-sentry-source-file="_app.tsx">
      <URLHistoryProvider data-sentry-element="URLHistoryProvider" data-sentry-source-file="_app.tsx">
        <AnimatePresence exitBeforeEnter data-sentry-element="AnimatePresence" data-sentry-source-file="_app.tsx">
          <Component key={router.asPath} {...pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
          <ToasterComponentDynamic data-sentry-element="ToasterComponentDynamic" data-sentry-source-file="_app.tsx" />
        </AnimatePresence>
      </URLHistoryProvider>
    </FrontasticProvider>;
}
export default appWithTranslation(FrontasticStarter);